export default __webpack_public_path__ + "static/media/eye_close.b4b98654.svg";